import type { ReceiptTemplate } from '../schema';

export const olaTemplate: ReceiptTemplate = {
  id: 'ola',
  name: 'Ola Ride Receipt',
  brand: 'Ola',
  description: 'Ola rideshare receipt template',
  settings: {
    width: 280,
    font: 'Arial',
    fontSize: 12,
    paperStyle: 'plain',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '₹',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ola-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ola.png',
        logoData: '',
        logoWidth: 80,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ola-title',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'RIDE RECEIPT',
        fontSize: 16,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'ola-ride-info',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 40,
        lines: [
          { id: 'ola-date', label: 'Date', value: '04 Jan 2026', isBold: false, isLarge: false },
          { id: 'ola-time', label: 'Time', value: '2:45 PM', isBold: false, isLarge: false },
          { id: 'ola-booking', label: 'Booking ID', value: 'CRN847291847', isBold: false, isLarge: false },
          { id: 'ola-vehicle', label: 'Vehicle', value: 'Ola Mini', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ola-route',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'FROM: Connaught Place, New Delhi\n\nTO: Indira Gandhi Airport T3',
        fontSize: 11,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ola-fare',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'ola-base', label: 'Base Fare', value: '49.00', isBold: false, isLarge: false },
          { id: 'ola-distance', label: 'Distance (18.4 km)', value: '184.00', isBold: false, isLarge: false },
          { id: 'ola-time-charge', label: 'Time (32 min)', value: '48.00', isBold: false, isLarge: false },
          { id: 'ola-toll', label: 'Toll Charges', value: '75.00', isBold: false, isLarge: false },
          { id: 'ola-gst', label: 'GST (5%)', value: '17.80', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ola-total',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'ola-total-amt', label: 'TOTAL', value: '373.80', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 25,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'ola-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'PAID VIA: Ola Money\nTransaction ID: TXN847291847291',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ola-driver',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Driver: Rajesh Kumar\nVehicle: DL 01 AB 1234 (Swift Dzire)',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'ola-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for riding with Ola!\nFor support: support@olacabs.com',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
